export default __webpack_public_path__ + "static/media/155.24573a2e.jpg";